import useAccountingIntegration from '@hooks/useAccountingIntegration'

import type { CreditNoteModel, InvoiceModel } from '@models/types'

import CreditNoteListItem from './CreditNoteListItem'
import InvoiceListItem from './InvoiceListItem'

type AccountingItem = InvoiceModel | CreditNoteModel;

interface InvoicesListViewProps {
  accountingItems: AccountingItem[],
  accountingIntegrationPayload: ReturnType<typeof useAccountingIntegration>,
}

const ListView = (props: InvoicesListViewProps) => {
  const { accountingIntegrationPayload, accountingItems } = props

  return (accountingItems.map((accountingItem) => {
    const { type } = accountingItem

    return (
      <>
        {type === 'CreditNote' && (
          <CreditNoteListItem
            accountingIntegrationPayload={accountingIntegrationPayload}
            creditNote={accountingItem}
            key={accountingItem.id}
          />
        )}

        {type === 'Invoice' && (
          <InvoiceListItem
            accountingIntegrationPayload={accountingIntegrationPayload}
            invoice={accountingItem}
            key={accountingItem.id}
          />
        )}
      </>
    )
  }))
}

export default ListView
